import { StatusData } from '@models/next/StatusData';
import { z } from 'zod';

export const PreAlertStatusName = z.enum(['-', '作成済', '修正中', 'LOCKED']);

export type PreAlertStatusName = z.TypeOf<typeof PreAlertStatusName>;

export const PreAlertStatus = StatusData.extend({
  name: PreAlertStatusName,
});

export type PreAlertStatus = z.infer<typeof PreAlertStatus>;
